var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8816 10.6311L9.13142 17.7027C8.94659 17.8915 8.69748 18 8.4323 18C8.16711 18 7.91639 17.892 7.73398 17.7011L0.983825 10.6296C0.617389 10.2092 0.63121 9.63463 1.01669 9.26498C1.3984 8.8971 2.01113 8.91092 2.38038 9.29763L7.46799 14.6289V0.964709C7.46799 0.432331 7.89992 0 8.39613 0C8.89235 0 9.3966 0.432331 9.3966 0.964709V14.6297L14.4833 9.29793C14.8512 8.9112 15.4641 8.89738 15.847 9.26529C16.2351 9.63464 16.2472 10.2092 15.8816 10.6311Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.1d4c0a69100b96ddd5b0b7b1b5ddc461.svg";
export { ForwardRef as ReactComponent };